import React from 'react'
import { Modal, Dialog, Text, SubHeading } from '@leroy-merlin-br/backyard-react-ui'

import Footer from './Footer'
import * as S from './styled'

const TermsOfUse = ({
  serviceId,
  name,
  acceptanceTerms = [],
  showTerms,
  onClose,
  onClickCallBack,
  productQuantity = 1
}) => {
  return (
    <Modal
      appElement="body"
      isOpen={showTerms}
      onClose={onClose}
      hasScroll
    >
      <Dialog
        hasScroll
        onClose={onClose}
        title={name}
        footer={<Footer
          onClose={onClose}
          onClick={() => {
            onClickCallBack(productQuantity)
            onClose()
          }}
        />}
      >
        <S.ServiceCode size="mega" as="div">
          Cod. do servico: {serviceId}
        </S.ServiceCode>
        <S.ScrollArea>
          <SubHeading as="h2" size="mega" noMargin>
            Condições do serviço de instalação
          </SubHeading>
          {
            acceptanceTerms.map(({ title, message }, index) => (
              <S.TermsTextWrapper key={`${serviceId}-${index}`} index={index}>
                <Text as="span" size="kilo" bold>
                  {title}
                </Text>
                <Text as="p" size="kilo">
                  {message}
                </Text>
              </S.TermsTextWrapper>
            ))
          }
        </S.ScrollArea>
      </Dialog>
    </Modal>
  )
}

export default React.memo(TermsOfUse)
